import React from "react";
import {
  FaPhoneAlt,
  FaMoneyBillAlt,
  FaRoad,
  FaShieldAlt,
  FaMapSigns,
  FaCar,
} from "react-icons/fa";

const Services = () => {
  return (
    <div className="container-fluid service py-5">
      <div className="container py-5">
        <div
          className="text-center mx-auto pb-5 wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "800px" }}
        >
          <h1 className="display-5 text-capitalize mb-3">
            Our <span className="text-primary">Services</span>
          </h1>
          <p className="mb-0">
            At Steward Cars, we offer a range of car rental services tailored to
            your travel needs in Kenya. Experience comfort and reliability with
            our fleet.
          </p>
        </div>
        <div className="row g-4">
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item p-4">
              <div className="service-icon mb-4">
                <FaPhoneAlt size={30} />
              </div>
              <h5 className="mb-3">Phone Reservation</h5>
              <p className="mb-0">
                Easily reserve your vehicle by calling our customer service
                team. We're here to assist you 24/7!
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item p-4">
              <div className="service-icon mb-4">
                <FaMoneyBillAlt size={30} />
              </div>
              <h5 className="mb-3">Competitive Rates</h5>
              <p className="mb-0">
                Enjoy special rates and discounts on long-term rentals. Get the
                best value for your journey!
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item p-4">
              <div className="service-icon mb-4">
                <FaRoad size={30} />
              </div>
              <h5 className="mb-3">One-Way Rentals</h5>
              <p className="mb-0">
                Convenient one-way rentals allow you to pick up your vehicle in
                one location and drop it off in another.
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item p-4">
              <div className="service-icon mb-4">
                <FaShieldAlt size={30} />
              </div>
              <h5 className="mb-3">Comprehensive Insurance</h5>
              <p className="mb-0">
                Drive with peace of mind with our comprehensive insurance
                options included in every rental.
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item p-4">
              <div className="service-icon mb-4">
                <FaMapSigns size={30} />
              </div>
              <h5 className="mb-3">City to City Rentals</h5>
              <p className="mb-0">
                Explore multiple cities in Kenya with our flexible city-to-city
                rental options.
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item p-4">
              <div className="service-icon mb-4">
                <FaCar size={30} />
              </div>
              <h5 className="mb-3">Free Rides for Loyalty Members</h5>
              <p className="mb-0">
                Join our loyalty program and enjoy free rides on selected
                bookings and exclusive offers!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
